<template>
  <v-app class="view">
    <v-dialog
        v-model="EditObjectDialog"
        max-width="300"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-8">
          <v-head>
            {{selectedObject.name}}
          </v-head>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                    v-model="selectedObject.accommodation_cost"
                    class="dialog-input"
                    label="ค่าที่พัก"
                    outlined
                    placeholder=""
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>


          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>

    <Menu :drawerWidth="drawer_width"></Menu>

    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <v-card>
          <v-card-title>
            จัดการค่าที่พัก
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="ค้นหา"
                single-line
            ></v-text-field>
          </v-card-title>
          <v-data-table
              v-if="objects && Array.isArray(objects)"
              :headers="[
                        { text: 'รายการ', value: 'name' },
                        { text: 'ค่าที่พัก', value: 'accommodation_cost' , width: '120px', fixed: true },
                        { text: 'แก้ไข', value: 'edit', width: '80px', fixed: true },
                      ]"
              :items="objects"
              :loading="objectsLoading"

              :search="search"
              class="elevation-1 mb-12 tr-clickable"
              @click:row="editObject"
          >
            <template v-slot:item.edit="{ item }">
              <v-btn class="primary" outlined small @click.stop="editObject(item)">แก้ไข</v-btn>
            </template>
            <template v-slot:item.enabled="{ item }">
              {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
            </template>
            <template v-slot:item.accommodation_cost="{ item }">
              {{ $helper.number_format(item.accommodation_cost) }}
            </template>
          </v-data-table>
<!--          <v-btn absolute-->

<!--                 bottom-->
<!--                 class="close-button float-left"-->
<!--                 color="primary"-->
<!--                 fab-->
<!--                 left @click="newObject">-->
<!--            <v-icon>mdi-plus</v-icon>-->
<!--          </v-btn>-->
        </v-card>


      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.theme--light .primary {
  color: #FFFFFF !important;
}


</style>
<script lang="ts">

import Menu from '@/components/Logistic/Menu.vue'
import {SimpleResponse} from '@/models/Model'
import {Province} from '@/models/Province'
import {DataArray} from '@/models/Response'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy,Menu},
})
export default class ViewLogisticProvince extends Vue {

  search = ''

  drawer_ratio = 0.15
  drawer_width = 200

  show_password = false

  objects: Province[] = []

  objectLoading = false
  objectsLoading = false
  EditObjectDialog = false
  selectedObject: Province | null = null

  async viewObject(object: Province) {
    await this.editObject(object)
  }

  async editObject(object: Province) {
    this.objectLoading = true

    this.EditObjectDialog = true

    if (object.id) {
      this.selectedObject = await (new Province()).load<Province>(object.id)
    }

    this.objectLoading = false

  }
  //
  // newObject() {
  //   this.selectedObject = new Province()
  //   this.selectedObject.datetime_start = '2021-01-01'
  //   this.selectedObject.datetime_end = '2021-12-31'
  //   this.selectedObject.enabled = true
  //   this.EditObjectDialog = true
  //
  // }

  cancel() {

    this.EditObjectDialog = false
  }

  async onSubmitObject() {
    this.objectLoading = true
    const isNew = this.selectedObject?.id === null

    this.selectedObject = Object.setPrototypeOf(this.selectedObject, Province.prototype)

    if (this.selectedObject) {
      try{
        let object = await this.selectedObject.save<Province>()
        this.$root.$emit('onSuccess', {message: "บันทึกสำเร็จ"})



        if (isNew) {
          this.objects.push(object)
        } else {
          for (let i in this.objects) {
            if (this.objects[i].id == object.id) {
              this.objects[i] = object
            }
          }
        }
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }
      this.objectLoading = false
    }
    this.selectedObject = null
    this.EditObjectDialog = false
  }

  async deletingObject() {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject()
      }
    })

  }

  async deleteObject() {
    try {
      if (this.selectedObject == null) return
      this.objectLoading = true

      this.selectedObject = Object.setPrototypeOf(this.selectedObject, Province.prototype)

      const response: SimpleResponse = await this.selectedObject?.delete()

      this.objects = this.objects.filter(object => object.id != this.selectedObject?.id)

      this.selectedObject = null
      this.EditObjectDialog = false

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
    this.objectLoading = false
  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)


    this.refreshProvince().then(() => {
    })
  }

  async refreshProvince() {
    const url = Helper.setting.province.getListAPI

    try {
      this.objectsLoading = true
      this.objects = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
    } catch (e) {
      alert(e)
    }
    this.objectsLoading = false
  }


}
</script>
